import Page from "~/pages/Page";
import {getApi, handleError} from "~/auth";
import $ from "jquery";
import {domSelectors} from "~/globals";
import {gotoHome, gotoLogin, navigateTo} from "~/utils";

class ConfirmEmail extends Page {
    constructor() {
        super("ConfirmEmail", "Conferma email");
    }

    async pageStart(): Promise<void> {
        let _ = this.spinner.spin();
        const op = $("#operation").val() as "signup" | "changeEmail" | "changeEmailContact";
        const returnUrl = $("#returnUrl").val() as string | null;
        
        try {
            let result = await getApi().confirmEmail(
                $("#userId").val() as string, 
                $("#code").val() as string,
                $("#changedEmail").val() as string,
                op
            );  
            await this.MailUpSubscription(result);
            if (returnUrl) 
                await navigateTo(returnUrl);
            else if (op === "changeEmailContact")
            {
                $("#waitmessage").toggleClass("d-none",true).hide(); 
                $("#changeVerified").toggleClass("d-none",false);
            }// stay here - await navigateTo("/il-tuo-profilo") 
            else if (op === "signup") 
                await gotoLogin("","La tua email è stata confermata. Effettua il login."); //TODO: I18n
            else await gotoHome();
            // TODO: mostrare messaggio di conferma
        } catch (e) {
            let errHtml = handleError(e);
            $("#waitmessage").html(errHtml);
        } finally {
            this.spinner.stop();
        }
    }

    private async MailUpSubscription(result: any): Promise<void> {
        if (result.consensi.filter((c: any) => c.codice === 'NEWS').length > 0) {
            return new Promise((resolve, reject) => {
                $.ajaxWithCredentials({
                    url: window.BaseUrlWebApi + 'MailUp/ConfermaRegistrazione',
                    method: 'GET',
                    data: {
                        idLista: window.ATP_ListID_Newsletter,
                        email: result.email,
                        nome: result.nome,
                        cognome: result.cognome ,
                        tipoutente: "Privato"
                    }
                })
                    .done(function (data, textStatus, jqXHR) {
                        resolve(data);
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        console.log(textStatus);
                        reject({jqXHR, textStatus, errorThrown});
                    })
                    .always(function () {
                        //this.RedirectLogin();
                    });
            });
        } else {
            return Promise.resolve();
        }
    }

    
}
export default ConfirmEmail;